export interface AssessmentContractFormData {
  agencyAssessmentContractSk: string;
  agencySk: string;
  contractSk: string;
  evaluationType: string;
  languageId: string;
  settingId: string;
  serviceArea: string;
  interpreterType: string;
  awardedRate: string;
  ownercontact: string;
  owneremail: string;
  ownerSe: string;
  tempContractNumber: string;
  agencyLocationSk: string;
}

export class SaveAssessmentContractModel {
  agencyAssessmentContractSk: string;
  agencySk: string;
  contractSk: string;
  evaluationType: string;
  languageId: string;
  settingId: string;
  serviceArea: string;
  interpreterType: string;
  awardedRate: string;
  ownercontact: string;
  owneremail: string;
  ownerSe: string;
  tempContractNumber: string;
  agencyLocationSk: string;
  constructor(data: AssessmentContractFormData) {
    this.agencyAssessmentContractSk = data?.agencyAssessmentContractSk;
    this.agencySk = data?.agencySk;
    this.contractSk = data?.contractSk;
    this.evaluationType = data?.evaluationType;
    this.languageId = data?.languageId;
    this.settingId = data?.settingId;
    this.serviceArea = data?.serviceArea;
    this.interpreterType = data?.interpreterType;
    this.awardedRate = data?.awardedRate;
    this.ownercontact = data?.ownercontact;
    this.owneremail = data?.owneremail;
    this.ownerSe = data?.ownerSe;
    this.tempContractNumber = data?.tempContractNumber;
    this.agencyLocationSk = data?.agencyLocationSk;
  }
}
